module.exports = __webpack_public_path__ + "img/needle_dashboard.04fc9980.png";